var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "30px",
    viewBox: "0 0 45 30",
    enableBackground: "new 0 0 45 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.673,0.323H1.327c-0.424,0-0.768,0.344-0.768,0.768v27.818c0,0.424,0.344,0.768,0.768,0.768h42.346 c0.426,0,0.768-0.344,0.768-0.768V1.091C44.44,0.667,44.099,0.323,43.673,0.323z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#484C52",
    cx: 12.025,
    cy: 15,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#484C52",
    cx: 22.5,
    cy: 15,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#484C52",
    cx: 32.975,
    cy: 15,
    r: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptions);
export default __webpack_public_path__ + "static/media/icon-options.c94a6d65.svg";
export { ForwardRef as ReactComponent };